import { render, staticRenderFns } from "./BulkEditFormFields.vue?vue&type=template&id=507875c8"
import script from "./BulkEditFormFields.vue?vue&type=script&lang=js"
export * from "./BulkEditFormFields.vue?vue&type=script&lang=js"
import style0 from "./BulkEditFormFields.vue?vue&type=style&index=0&id=507875c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports